import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolGroupsAction } from './symbolGroups.action';
import { symbolGroupsInitialState } from './symbolGroups.constant';

export const symbolGroupsReducer = reducerWithInitialState(symbolGroupsInitialState)
  .case(SymbolGroupsAction.load.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(SymbolGroupsAction.load.done, (state, { result }) => {
    return {
      ...state,
      symbolGroups: result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolGroupsAction.load.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(SymbolGroupsAction.destroy, () => ({
    ...symbolGroupsInitialState,
  }));
